import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'dcc-live-syslog-help',
  templateUrl: './live-syslog-help.component.html',
})
export class LiveSyslogHelpComponent {
  constructor(public activeModal: NgbActiveModal) {}
}
